import * as libLocation from "./lib/location.ts";
import * as Html from "./util/Html.ts";
import * as amplify from "./util/amplify.ts";
import * as DarkMode from "./DarkMode.ts";
import "./lib/Screen.ts";
import "./lib/FileUtils.ts";
import "./lib/tooltip.ts";

Html.registerDom({
  print(){
    window.print();
  },
  darkmode(val){
    const parent = this.parentElement;
    if(parent){
      Array.from(parent.children).forEach(child => child.classList.remove('selected'));
    }
    this.classList.add('selected');
    if(val==='light' || val==='dark' || val===undefined){
      DarkMode.changePreference(val);
    }else{
      throw new Error('invalid dark mode value '+val)
    }
  },
  goto(page){
    page = page.replace('$metaId', Html.getDomMetaId(this));
    libLocation.goTo(page);
  },
  openurl(page){
    window.open(page,"_blank");
  },
  goback(page){
    if(page){
      libLocation.goBack(page);
    }else{
      history.back();
    }
  },
  refresh(){
    libLocation.refresh();
  },
  submit(){
    const element = this;
    // Find the form element (could be called on a button or the form itself)
    const form = (element.tagName === 'FORM' ? element : element.closest('form')) as HTMLFormElement;
    if (form) {
      const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
      // Gecko runs the default action of an untrusted submit event, which navigates away
      // and cancels the pending work of the listeners. Cancel the event upfront: the
      // listeners still run, only the native submission is skipped.
      submitEvent.preventDefault();
      form.dispatchEvent(submitEvent);
    }
  },
  submitnode(){
    this.dispatchEvent(new Event('submitnode', { bubbles: true, cancelable: true }));
  },
  reset(){
    const form = this.closest('form') as HTMLFormElement;
    if(form) form.dispatchEvent(new Event('reset'));
  },
  amplify(name){
    amplify.publish(name)
  },
  stoppropagation(){
    return true;
  },
  clickprev(){
    const prev = this.previousElementSibling as HTMLElement;
    if(prev) prev.click();
  },
  accordionclick(){
    const parent = this.parentElement;
    if(parent){
      let sibling = parent.nextElementSibling;
      while(sibling){
        (sibling as HTMLElement).style.display = (sibling as HTMLElement).style.display === 'none' ? '' : 'none';
        sibling = sibling.nextElementSibling;
      }
    }
    this.classList.toggle('rotate180')
  },
  mailto(email){
    window.location.href = 'mailto:'+email;
  }

});